import { List } from "@mui/material";

import { useMenu } from "components/Menu/context";
import { MenuNodeType } from "components/Menu/model";

import { MenuContainerNode } from "../MenuContainerNode";
import { MenuLinkNode } from "../MenuLinkNode";
import { MenuSectionLabelNode } from "../MenuSectionLabelNode";

export const MainMenuListItems = () => {
  const { setSelectedMainMenuTitleKey, selectedMainMenuTitleKey, menuModel } =
    useMenu();

  const handleMainMenuClick = (titleKey: string) => {
    setSelectedMainMenuTitleKey(titleKey);
  };

  return (
    <List component="nav" data-testid="main-menu-nav">
      {menuModel.childNodes?.map((childNode, idx) => {
        const key = `${childNode.titleKey}${childNode.nodeType ?? ""}${idx}`;
        switch (childNode?.nodeType) {
          case "topLevelLink":
            return <MenuLinkNode node={childNode} key={key} focus={false} />;
          case "sectionLabel":
            return (
              <MenuSectionLabelNode
                isMainMenu
                key={key}
                titleKey={childNode.titleKey}
              />
            );
          default:
            return (
              <MenuContainerNode
                key={key}
                onMenuClick={handleMainMenuClick}
                selectedMainMenuTitleKey={selectedMainMenuTitleKey}
                node={childNode as MenuNodeType.Container}
              />
            );
        }
      })}
    </List>
  );
};
